<template>
    <div>
        <v-card elevation="0" flat>
            <v-card-text>
                <v-card elevation="0" outlined style="border-color:#D8A7B1;">
                    <!-- <v-alert color="orange" text type="warning">This page is currently under development</v-alert> -->
                    <v-card-text>
                        <v-row>
                            <v-col cols="6">
                                <v-select dense outlined :items="allowedDepartments" :loading="departmentloading" v-model="filterValues.department">
                                    <template v-slot:prepend>Department: </template>
                                </v-select>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field dense outlined persistent-hint hint="Optional"  v-model="filterValues.strm">
                                    <template v-slot:prepend>Strm: </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-menu
                                    v-model="menustart"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field class="ma-2" dense v-model="filterValues.startdate" label="Posting Start Date" persistent-hint hint="Optional" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                                    </template>
                                    <v-date-picker v-model="filterValues.startdate" no-title color="#D4C88D" @input="closeMenuStart"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="6">
                                <v-menu
                                    v-model="menuend"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field class="ma-2" dense v-model="filterValues.enddate" label="Posting End Date" persistent-hint hint="Optional" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                                    </template>
                                    <v-date-picker v-model="filterValues.enddate" :show-current="filterValues.startdate" no-title color="#D4C88D" :allowed-dates="validateEndDate" @input="closeMenuEnd"></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn depressed color="#D8A7B1" class="white--text" :loading="reportloading" @click="runReport" :disabled="departmentloading || filterValues.department == ''">Run Report on Postings</v-btn>
                    </v-card-actions>
                </v-card>
                <br /><v-divider></v-divider><br />
                <v-card elevation="0" outlined style="border-color:#D8A7B1;">
                    <v-overlay absolute v-if="reportloading">
                        <v-progress-circular :size="50" color="#D8A7B1" indeterminate></v-progress-circular>
                    </v-overlay>
                    <v-card-actions>
                        <v-btn color="#D8A7B1" class="white--text" @click="downloadReport" :loading="downloading" :disabled="reportResults.length == 0">Download CSV</v-btn>
                    </v-card-actions>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">Total of {{ reportResults.length }} postings returned</v-col>
                            <v-col cols="12">
                                <v-simple-table style="border-collapse: collapse;" dense fixed-header max-height="800px">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>Strm</th>
                                                <th>Posting Title</th>
                                                <th>Department</th>
                                                <th>Discipline</th>
                                                <th>Type</th>
                                                <th>Catalog(s)</th>
                                                <th>Section(s)</th>
                                                <th>Start Date</th>
                                                <th>End Date</th>
                                                <th>Status</th>
                                                <th>Filled</th>
                                                <th>Filled Applicant</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="posting in reportResults">
                                                <td>{{ posting.strm }}</td>
                                                <td>{{ posting.title }}</td>
                                                <td>{{ posting.department }}</td>
                                                <td>{{ posting.discipline }}</td>
                                                <td>{{ posting.type }}</td>
                                                <td>{{ posting.catalogs }}</td>
                                                <td>{{ posting.sections }}</td>
                                                <td>{{ posting.startDate }}</td>
                                                <td>{{ posting.endDate }}</td>
                                                <td>{{ posting.status }}</td>
                                                <td>{{ posting["filled-position"] }}</td>
                                                <td>{{ posting["filled-applicant"] }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import auth from '@/js/auth';
export default {
    data(){
        return {
            host: location.hostname.toString(),
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            allowedDepartments: [],
            departmentloading: false,
            downloading: false,
            reportloading: false,
            menustart: false,
            menuend: false,
            filterValues: {
                department: "",
                strm: "",
                startdate: "",
                enddate: ""
            },
            reportResults: []
        }
    },
    methods: {
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        },
        getPermissions(){
            const that = this;
            let permission = auth.get_permissions();

            if(permission.hasOwnProperty('allowedDepartments')){
                that.allowedDepartments = permission.allowedDepartments;

                that.allowedDepartments.push("All");
            }else if(permission.hasOwnProperty("rootgroup") && permission["rootgroup"] == 1){
                that.getDepartment();
            }
        },
        getDepartment(){
            const that = this;
            that.departmentloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getacademicdepartments';
            var deps = []
            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            json.data.forEach(element => {
                                deps.push(element["department"]);
                            });
                        }

                        that.allowedDepartments = deps;
                        if(deps.length > 1){
                            that.allowedDepartments.push("All");
                        }

                    }else {
                        that.setSnackbar("Warning: "+json.message, "#EF6C00"); //orange
                    }

                    that.departmentloading = false;
                    
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.departmentloading = false;
                })
        },
        validateEndDate(val){
            const that = this;

            return val >= that.filterValues.startdate
        },
        closeMenuStart(){
            const that= this;
            that.menustart = false;
        },
        closeMenuEnd(){
            const that= this;
            that.menuend = false;
        },
        runReport(){
            const that = this;

            that.reportloading = true;

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';

            let filtervalues = {
                "department": []
            }

            if(that.filterValues.department == "All"){
                filtervalues = {
                    "department": that.allowedDepartments
                }
            }else {
                filtervalues = {
                    "department": [that.filterValues.department]
                }
            }

            if(that.filterValues.strm != ""){
                filtervalues["strm"] = that.filterValues.strm
            }
            
            if(that.filterValues.startdate != "" && that.filterValues.startdate != null){
                filtervalues["datestart"] = that.filterValues.startdate
            }

            if(that.filterValues.enddate != "" && that.filterValues.enddate != null){
                filtervalues["dateend"] = that.filterValues.enddate
            }

            const formData = new FormData();
            formData.append("mode", "reportrun");
            formData.append("data", JSON.stringify(filtervalues));

            fetch(api, {
                method: 'POST',
                body: formData
            })
            .then(function(response){
                return response.json();
            })
            .then(function (data) {
                if(data.result.match(/ok/i)){
                    that.setSnackbar("Successful: "+data.message.toString(), "green");

                    that.reportResults = data.data;

                }else {
                    that.setSnackbar("Warning: "+data.message.toString(), "orange");
                    that.reportResults = [];
                }

                that.reportloading = false;
            })
            .catch(function (err) {
                that.setSnackbar("Error occurred : "+err.toString(), "red");
                that.reportResults = [];
                that.reportloading = false;
            })
        },
        downloadReport(){
            const that = this;

            that.downloading = true;

            let filtervalues = {
                "department": []
            }

            if(that.filterValues.department == "All"){
                filtervalues = {
                    "department": that.allowedDepartments
                }
            }else {
                filtervalues = {
                    "department": [that.filterValues.department]
                }
            }

            if(that.filterValues.strm != ""){
                filtervalues["strm"] = that.filterValues.strm
            }
            
            if(that.filterValues.startdate != "" && that.filterValues.startdate != null){
                filtervalues["datestart"] = that.filterValues.startdate
            }

            if(that.filterValues.enddate != "" && that.filterValues.enddate != null){
                filtervalues["dateend"] = that.filterValues.enddate
            }

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=reportdownload&data='+JSON.stringify(filtervalues);

            fetch(api)
            .then(function(response){
                return response;
            })
            .then(function(data){
                that.downloading = false;
                that.setSnackbar("Successful - Download starting", "green");
                window.open(api);
            })
            .catch(function (err) {
                that.setSnackbar("Error occurred : "+err.toString(), "red");

                that.downloading = false;
            });

        }
    },
    created(){
        this.getPermissions();
    }
}
</script>